module.exports = __webpack_public_path__ + "static/use-case-5-content-6-8c3f827edc584aee92e6698014cadda7.png";